export default __webpack_public_path__ + "static/media/dc.a44ed0be.gif";